import { Link, NavLink } from "react-router-dom";
import { FaRegHandshake } from "react-icons/fa";
import { ROUTES } from "../../../constants/_routes";
import ProfileIcon from "../Icons/ProfileIcon";
import AboutIcon from "../Icons/AboutIcon";
import TermsIcon from "../Icons/TermsIcon";
import ContactUsIcon from "../Icons/ContactUsIcon";
import SignOutIcon from "../Icons/SignOutIcon";
import MerchantIcon from "../Icons/MerchantIcon";
import ReceivedMoneyIcon from "../Icons/ReceivedMoneyIcon";
import RentIcon from "../Icons/RentIcon";
import LanguageBtn from "../../Common/LanguageBtn/LanguageBtn";

export function buildMoreDropdownItems({
  dir,
  t,
  isEmirates,
  handleCloseMenu,
  setShowProfileDrawer,
  setIsTermsModalOpen,
  handleContact,
  handleShowReceived,
  moneyCount,
  location,
}) {
  return [
    {
      key: 0,
      label: (
        <li dir={dir} className="nav-item" onClick={handleCloseMenu}>
          <button
            type="button"
            onClick={() => setShowProfileDrawer(true)}
            className="w-100 p-0 bg-transparent border-0 outline-none shadow-none d-flex gap-2 gap-md-1 align-items-center"
          >
            <ProfileIcon />
            <span className="recycle-nav__nav-titles text-center fsize-12">
              {t("nav.profile")}
            </span>
          </button>
        </li>
      ),
    },
    {
      key: 1,
      label: (
        <>
          {!isEmirates && (
            <li className="nav-item">
              <NavLink
                to={ROUTES.ABOUT}
                dir={dir}
                className="nav-link p-0 text-decoration-none d-flex gap-2 gap-md-1 align-items-center"
              >
                <AboutIcon />
                <span className="recycle-nav__nav-titles text-center fsize-12">
                  {t("nav.about")}
                </span>
              </NavLink>
            </li>
          )}
        </>
      ),
    },
    ...(isEmirates
      ? []
      : [
          {
            key: 2,
            label: (
              <li className="nav-item">
                <NavLink
                  to={ROUTES.MERCHANT}
                  dir={dir}
                  onClick={handleCloseMenu}
                  className="nav-link p-0 text-decoration-none d-flex gap-2 gap-md-1 align-items-center"
                >
                  <MerchantIcon />
                  <span className="recycle-nav__nav-titles text-center fsize-12">
                    {t("nav.merchant")}
                  </span>
                </NavLink>
              </li>
            ),
          },
          {
            key: "more-received",
            label: (
              <li dir={dir} className="nav-item" onClick={handleCloseMenu}>
                <button
                  type="button"
                  onClick={handleShowReceived}
                  className="w-100 p-0 bg-transparent border-0 outline-none shadow-none d-flex gap-2 gap-md-1 align-items-center"
                >
                  <div className="position-relative d-flex">
                    {moneyCount > 0 && (
                      <span
                        className="recycle-nav__offers-count active-offer"
                        style={{ right: "-5px" }}
                      >
                        {moneyCount > 99 ? "99+" : moneyCount}
                      </span>
                    )}
                    <ReceivedMoneyIcon />
                  </div>
                  <span className="recycle-nav__nav-titles text-center fsize-12">
                    {t("nav.received")}
                  </span>
                </button>
              </li>
            ),
          },
          {
            key: "more-partnerships",
            label: (
              <li className="nav-item">
                <NavLink
                  to={ROUTES.PARTNERSHIPS}
                  dir={dir}
                  onClick={handleCloseMenu}
                  className="nav-link p-0 text-decoration-none d-flex gap-2 gap-md-1 align-items-center"
                >
                  <FaRegHandshake
                    className="recycle-nav__nav-icon"
                    style={{
                      color: location.pathname.endsWith(ROUTES.PARTNERSHIPS)
                        ? "#13c156"
                        : "#fff",
                    }}
                  />
                  <span className="recycle-nav__nav-titles text-center fsize-12">
                    {t("nav.partnership")}
                  </span>
                </NavLink>
              </li>
            ),
          },
          {
            key: "more-rent",
            label: (
              <li className="nav-item">
                <NavLink
                  to={ROUTES.RENT_WAREHOUSE}
                  dir={dir}
                  onClick={handleCloseMenu}
                  className="nav-link p-0 text-decoration-none d-flex gap-2 gap-md-1 align-items-center"
                >
                  <RentIcon
                    color={
                      location.pathname === ROUTES.RENT_WAREHOUSE
                        ? "#13c156"
                        : "#ffffff"
                    }
                  />
                  <span className="recycle-nav__nav-titles text-center fsize-12">
                    {t("nav.rentSpace")}
                  </span>
                </NavLink>
              </li>
            ),
          },
          {
            key: 3,
            label: (
              <li dir={dir} className="nav-item" onClick={handleCloseMenu}>
                <button
                  type="button"
                  onClick={() => setIsTermsModalOpen(true)}
                  className="w-100 p-0 bg-transparent border-0 outline-none shadow-none d-flex gap-2 gap-md-1 align-items-center"
                >
                  <TermsIcon />
                  <span className="recycle-nav__nav-titles text-center fsize-12">
                    {t("nav.terms")}
                  </span>
                </button>
              </li>
            ),
          },
        ]),
    {
      key: 4,
      label: (
        <li dir={dir} className="nav-item" onClick={handleCloseMenu}>
          <Link
            to={"#"}
            onClick={handleContact}
            className="nav-link p-0 d-flex gap-2 gap-md-1 align-items-center"
          >
            <ContactUsIcon />
            <span className="recycle-nav__nav-titles text-center fsize-12">
              {t("nav.contactUs")}
            </span>
          </Link>
        </li>
      ),
    },
    {
      key: 5,
      label: (
        <li dir={dir} className="nav-item" onClick={handleCloseMenu}>
          <LanguageBtn inNavMoreMenu />
        </li>
      ),
    },
    {
      key: 6,
      label: (
        <li dir={dir} className="nav-item">
          <Link
            to={ROUTES.LOGOUT}
            className="nav-link p-0 d-flex gap-2 gap-md-1 align-items-center"
          >
            <SignOutIcon />
            <span className="recycle-nav__nav-titles text-center fsize-12">
              {t("nav.signout")}
            </span>
          </Link>
        </li>
      ),
    },
  ];
}
